import * as CL from '@design-system/component-library';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { useSearchParams } from '../../common/hooks/useSearchParams.js';
import { newDeviceSelectionMsg, productTypeMsg, t } from '../../common/i18n/index.js';
import {
  DEVICE_SELECTION_PRODUCT_TYPES,
  DEVICE_SELECTION_PRODUCT_TYPE_PARAM,
  FILTER_VALUE_SEPARATOR,
  MDM_ID_PARAM,
  getDeviceSelectionProductTypeLabel,
  getNewDeviceSelectionPath,
} from '../../common/utils/deviceListTabsUtilsCoCo.js';
import { ListSearch, SearchFilters } from '../Table/index.js';
import type { SearchFilterGroup } from '../Table/SearchFilters.js';

const getProductTypeFilterGroup = (productTypeFilter?: string): SearchFilterGroup => {
  const selected = productTypeFilter?.split(FILTER_VALUE_SEPARATOR) ?? [];
  return {
    label: () => t.R6HP(productTypeMsg),
    value: DEVICE_SELECTION_PRODUCT_TYPE_PARAM,
    items: DEVICE_SELECTION_PRODUCT_TYPES.map(productType => ({
      label: () => getDeviceSelectionProductTypeLabel(productType),
      value: productType,
      checked: selected.includes(productType),
    })),
  };
};

export const DeviceSelectionToolbarCoCo = () => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const navigate = useNavigate();
  const { [DEVICE_SELECTION_PRODUCT_TYPE_PARAM]: productTypeFilter, [MDM_ID_PARAM]: mdmId } = useSearchParams<{
    [DEVICE_SELECTION_PRODUCT_TYPE_PARAM]?: string;
    [MDM_ID_PARAM]?: string;
  }>();
  const filterGroups = [getProductTypeFilterGroup(productTypeFilter)];

  return (
    <div className={`of-device-selection-toolbar-coco ${dsClass.MARGIN_TOP_4}`}>
      <div className="of-device-selection-toolbar-coco__row">
        <div className="of-device-selection-toolbar-coco__search">
          <ListSearch filtersOpen={filtersOpen} setFiltersOpen={setFiltersOpen} />
        </div>
        <CL.Button
          className="of-device-selection-toolbar-coco__new-button"
          color="primary"
          onClick={() => navigate(getNewDeviceSelectionPath(mdmId))}
        >
          {`+ ${t.DLV8(newDeviceSelectionMsg)}`}
        </CL.Button>
      </div>
      <SearchFilters
        displayActiveFiltersAsTiles={!filtersOpen}
        filterGroups={filterGroups}
        onModalClose={() => setFiltersOpen(false)}
      />
    </div>
  );
};
